import * as React from 'react'
import './GlossaryItemLinks.css';
import { Link } from './GlossaryService';

export interface Props {
    label: string;
    links?: Link[];
}

export interface State {

}

export class GlossaryItemLinksComponent extends React.Component<Props, State> {
    render() {
        const { links, label } = this.props;

        if(links == null || links.length == 0) {
            return null;
        }

        const linkz = links.map(related => 
            <a className="related-links-container-link" href={related.link} key={related.link}>
                {related.text} 
            </a>
        )

        return (
            <div className="related-links-container">
                <div className="related-links-container-title">{label}:</div>
                {
                    linkz
                }
            </div>
        )
    }
}

export default GlossaryItemLinksComponent;


// WEBPACK FOOTER //
// ./src/glossary/GlossaryItemLinks.tsx